import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogCloneItemComponent } from './catalog-clone-item.component';
import { CtButtonModule, CtControlModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    CtButtonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    CtControlModule
  ],
  declarations: [CatalogCloneItemComponent],
  exports: [CatalogCloneItemComponent]

})
export class CatalogCloneItemModule { }
